module.exports = __webpack_public_path__ + "static/media/Weapon_03.e01de902.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GameTheme/WeaponComponent/Weapon_03.png
// module id = 1384
// module chunks = 0